import Ripple from './Ripple';

export { Ripple };


// WEBPACK FOOTER //
// ./src/baseComponents/directives/Ripple/index.js